export default {
  edit_note: 'Edytuj notatkę',
  add_note: 'Dodaj notatkę ',
  update: 'Zaktualizuj produkt',
  feedback: {
    item_sold_out_one: 'Przepraszamy, ale aktualnie nie mamy {{items}}.',
    item_sold_out_few: 'Przepraszamy, obecnie brak: {{items}}.',
    item_sold_out_many: 'Przepraszamy, obecnie brak: {{items}}.',
    item_sold_out_other: 'Przepraszamy, ale aktualnie nie mamy {{items}}.',
    item_unavailable:
      'Ten produkt jest dostępny od {{schedule}}. Zmień godzinę zamówienia lub usuń produkt, aby zamówić.',
  },
  buttons: {
    update: 'Zaktualizuj',
  },
};
